import { render, staticRenderFns } from "./Modal.vue?vue&type=template&id=f1537fd8"
import script from "./Modal.vue?vue&type=script&lang=js"
export * from "./Modal.vue?vue&type=script&lang=js"
import style0 from "./Modal.vue?vue&type=style&index=0&id=f1537fd8&prod&lang=css"
import style1 from "./Modal.vue?vue&type=style&index=1&id=f1537fd8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports